import Path from '@leverege/path'

function isSameObject( obj1, obj2 ) {
  if ( obj1 === obj2 ) {
    return true
  }

  if ( obj1 != null ) {
    const keys1 = Object.keys( obj1 )
    if ( obj2 == null ) {
      return keys1.length === 0
    }

    if ( keys1.length !== Object.keys( obj2 ).length ) {
      return false
    }

    for ( let i = 0; i < keys1.length; i++ ) {
      if ( obj1[keys1[i]] !== obj2[keys1[i]] ) {
        return false
      }
    }

    return true
  } 

  return Object.keys( obj2 ).length === 0
}

function getAccess( lookupItem ) {
  let accessor

  if ( typeof lookupItem === 'object' ) {
    accessor = lookupItem.accessor
  } else {
    accessor = lookupItem
  }

  if ( typeof accessor === 'string' ) {
    return Path( accessor ).get
  }

  return accessor
}

export default {
  getAccess,
  isSameObject
}
